import React from 'react'
import './Skeleton.css'
function SkeletonRecentGroup() {
  return (
    <div className="container-box">
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
    <div className="post">
        <div className="avatar"></div>
        <div className="line"></div>
        <div className="line"></div>
    </div>
</div>
  )
}

export default SkeletonRecentGroup